import { render, staticRenderFns } from "./variant1.vue?vue&type=template&id=221876e3&scoped=true"
import script from "./variant1.vue?vue&type=script&lang=js"
export * from "./variant1.vue?vue&type=script&lang=js"
import style0 from "./variant1.vue?vue&type=style&index=0&id=221876e3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221876e3",
  null
  
)

export default component.exports